module.exports = require('./../dist/svg-components/fontawesome/AngleDown');